<template>
   <div class="content__container">
      <aside :class="asideClass">
         <div class="aside__content">
            <slot name="sidebar"></slot>
         </div>
      </aside>
      <main class="main">
         <slot name="main"></slot>
      </main>
   </div>
</template>

<script>
export default {
   props: {
      position: { type: String, default: 'left' }
   },
   computed: {
      asideClass() {
         const { position } = this

         return [
            position == 'left' ? 'aside aside--left' : 'aside aside--right'
         ]
      }
   }
}
</script>

<style lang="scss" scoped>
   @import '~/assets/SCSS/Base/00_functions.scss';
   @import '~/assets/SCSS/Base/01_variables.scss';
   @import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Vana/sidebar.scss';
</style>